/* eslint-disable @typescript-eslint/camelcase */
import i18n from 'i18n';
import * as Yup from 'yup';

export default completion_date => {
  return Yup.object().shape({
    completion_date_reason: Yup.string()
      .required(i18n.t('REQUIRED_FIELD_KEY'))
      .max(
        280,
        i18n.t('REQUIRE_MAX_LENGTH_TEXT_KEY', {
          max_length: 280,
        })
      ),
    completion_date_proposed: Yup.date().min(
      completion_date,
      i18n.t('COMPLETION_DATE_PROPOSE_RULE_KEY')
    ),
  });
};
